// Sources (MUI, /sources). Presentation port of SourcesPage — phase placeholders
// for ingestion connectors, rebuilt with mui/* primitives + brainTokens.
import { Box } from "@mui/material";
import { brainTokens } from "../../design/brainTheme";
import { PageHeader, SectionCard, StatusPill } from "../../mui";

const c = brainTokens.color;

function PhaseEmptyStateMui({ title, phase, children }: { title: string; phase: string; children: string }) {
  return (
    <SectionCard>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mb: 1 }}>
        <Box sx={{ fontSize: 15, fontWeight: 500, color: c.ink }}>{title}</Box>
        <StatusPill tone="neutral" label={`Needs ${phase}`} />
      </Box>
      <Box sx={{ fontSize: 13, color: c.muted2 }}>{children}</Box>
    </SectionCard>
  );
}

export function SourcesPageMui() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <PageHeader title="Sources" eyebrow="Ingestion status" />
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" }, gap: 2 }}>
        <PhaseEmptyStateMui title="Confluence" phase="Phase 5 / GET /admin/sources">
          Connector status, last run, doc counts, skipped, and failures are not exposed yet.
        </PhaseEmptyStateMui>
        <PhaseEmptyStateMui title="Jira" phase="Phase 5 / GET /admin/sources">
          Webhook health and project-scope mapping will appear once ingestion state is live.
        </PhaseEmptyStateMui>
        <PhaseEmptyStateMui title="Docs Sync" phase="Phase 5b">
          Registry-backed docs and work-state sync are deferred until the docs repo exists.
        </PhaseEmptyStateMui>
      </Box>
    </Box>
  );
}
